import { useEffect } from "react";

// O Escape fecha a tooltip de um grafico (WCAG 1.4.13: o conteudo que aparece no foco ou com o rato
// tem de se poder fechar sem mover nem um nem outro). Escuta no documento enquanto a tooltip esta
// aberta, porque com o rato o foco pode estar fora do grafico e o Escape nunca chegava a marca.
const useHideOnEscape = (open, hide) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") hide();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, hide]);
};

export default useHideOnEscape;
